<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mzJ4SN/tc-custom/9780830841820.jpg?1696025098384" alt="This image is the cover for the book Gender Identity and Faith, Christian Association for Psychological Studies Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gender Identity and Faith, Christian Association for Psychological Studies Books
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Helping people navigate gender identity questions today is complex and often polarized work.</strong> For clients and families who are also informed by their faith, some mental health approaches raise more questions than answers. Clinicians need a client-centered, open-ended approach that makes room for gender exploration while respecting religious identity. <em>Gender Identity and Faith</em> carves out clinical space for mental health professionals to help people who wish to take seriously their gender identity, their religious identity, <em>and</em> the relationship between the two. Drawing from their extensive research and experience with clients, Mark Yarhouse and Julia Sadusky provide a timely, practical resource for practitioners. This book</p>  emphasizes respect for clients' journeys, without a single fixed outcome, toward congruence between their gender identity and faith describes effective clinical postures, assessment and therapeutic tools, and numerous case studies covers needs and characteristics of children, youth, and adult clients includes worksheets and prompts for clients and family members  <p>"Integrating personhood and values is no easy feat, especially in our current cultural landscape," the authors write. Those navigating this intersection need clinicians who seek to understand their unique context and journey alongside them with empathy. This book points the way.</p> <p>Christian Association for Psychological Studies (CAPS) Books explore how Christianity relates to mental health and behavioral sciences including psychology, counseling, social work, and marriage and family therapy in order to equip Christian clinicians to support the well-being of their clients.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark A. Yarhouse, Julia A. Sadusky
      </h2>
      
      <p class="authorDescription body article"><p>Mark A. Yarhouse (PsyD, Wheaton College) is the Dr. Arthur P. Rech and Mrs. Jean May Rech Endowed Chair and professor of psychology at Wheaton College, where he directs the Sexual and Gender Identity (SGI) Institute. He is a licensed clinical psychologist and author or coauthor of several books, including <em>Understanding Gender Dysphoria</em>, <em>Modern Psychopathologies</em>, <em>Understanding Sexual Identity</em>, and <em>Family Therapies</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58597d89